    document.querySelectorAll('.collection-tabs-section .product-grid-slider').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '0rem',
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3, // For screens <= 1024px
        },
        768: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '0',
          focus: 'center',
        },
        640: {
          perPage: 1,
          fixedWidth: '70%',
          gap: '0',
          focus: 'center',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });

  document.querySelectorAll('.manual-carousel-wrapper .carousel').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '24px',
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3, // For screens <= 1024px
        },
        768: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '15px',
          focus: 'center',
        },
        640: {
          perPage: 1,
          fixedWidth: '70%',
          gap: '15px',
          focus: 'center',
        },
        480: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '10px',
          focus: 'center',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });
  
  document.querySelectorAll('.capsule-products.fall-capsule-slider').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '20px',
      arrows: false,
      pagination: false,
      breakpoints: {
        768: {
          gap: '10px',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });

  const tabs = document.querySelectorAll('.collection-tabs-section .tab-button');
  const contents = document.querySelectorAll('.collection-tabs-section .tab-content');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((btn) => btn.classList.remove('active'));
      contents.forEach((content) => content.classList.remove('active'));
      tab.classList.add('active');
      document.querySelector(`.tab-content[data-tab-index="${index}"]`).classList.add('active');
    });
  });
  
  /* sticky header js */
  window.addEventListener('scroll', function () {
    const header = document.getElementById('header-group');
    const stickyOffset = header.offsetTop;

    if (window.scrollY > stickyOffset) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  });

  /* mobile menu js */

  const submenuToggles = document.querySelectorAll(".menu-drawer__menu .submenu-toggle");

  submenuToggles.forEach((toggle) => {
    const parentLi = toggle.closest("li");
    const submenu = parentLi.querySelector(".menu-level-2");

    if (!submenu) return;

    const backButton = submenu.querySelector(".back-button");

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      submenu.classList.add("active");
    });

    backButton.addEventListener("click", (e) => {
      e.preventDefault();
      submenu.classList.remove("active");
    });
  });

  const accordionHeaders = document.querySelectorAll(".mm-menu-grid .mm-menu-wrapper h3");
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const item = header.parentElement;
      item.classList.toggle("active");
    });
  });

  document.querySelectorAll('ul.menu-drawer__menu > li a').forEach(item => {
    item.addEventListener('click', function (e) {
      const nextEl = this.nextElementSibling;

      if (nextEl && nextEl.classList.contains('submenu-toggle')) {
        e.preventDefault();
        nextEl.click(); 
      }
    });
  });

/* on  swatch hover change cart product image */
document.querySelectorAll('.custom-product-card .product-swatches a').forEach(swatch => {

    // swatch.addEventListener('mouseenter', function() {
    //     swatch.closest('.product-swatches').querySelectorAll('a.swatch.active').forEach(item => {
    //       item.classList.remove('active');
    //     });
    //     swatch.classList.add('active');
    //     const swatchURL = swatch.dataset.image;
    //     const imgElement = swatch.closest('.custom-product-card').querySelector('img');
    //     if (imgElement) {
    //         imgElement.src = swatchURL;
    //         imgElement.srcset = swatchURL;
    //     }
    // });

    swatch.addEventListener('click', function(e) {
        e.preventDefault();
        swatch.closest('.product-swatches').querySelectorAll('a.swatch.active').forEach(item => {
          item.classList.remove('active');
        });
        swatch.classList.add('active');
        const swatchURL = swatch.dataset.image;
        const imgElement = swatch.closest('.custom-product-card').querySelector('img');
        if (imgElement) {
            imgElement.src = swatchURL;
            imgElement.srcset = swatchURL;
        }
    });
});


/* Add .has-mega-hover when window width >= 990 */
function setupMegaMenuHover() {
  const headerGroup = document.getElementById('header-group');
  const menuItems = document.querySelectorAll('.header-menu__inner li');

  // First, remove any previously attached listeners
  menuItems.forEach(li => {
    const clone = li.cloneNode(true);
    li.replaceWith(clone);
  });

  if (window.innerWidth >= 990) {
    document.querySelectorAll('.header-menu__inner li').forEach(li => {
      if (li.querySelector('.mega-menu-wrapper')) {
        li.addEventListener('mouseenter', () => {
          headerGroup.classList.add('has-mega-hover');
        });
        li.addEventListener('mouseleave', () => {
          headerGroup.classList.remove('has-mega-hover');
        });
      }
    });
  } else {
    headerGroup.classList.remove('has-mega-hover'); // Just in case
  }
}
// Run on page load
window.addEventListener('DOMContentLoaded', setupMegaMenuHover);
// Run on resize
window.addEventListener('resize', setupMegaMenuHover);


/* sticky add to cart js */
document.querySelectorAll('.sticky-atc-btns .option-btns-wrap .option-btns').forEach(item => {
    item.addEventListener('click', function() {
        const option_name = item.dataset.option;
        document.querySelector('.sticky-atc-btns .floating-option').style.display = 'block';
        document.querySelectorAll(`.sticky-atc-btns .floating-option .option-values`).forEach(item => { item.classList.remove('active'); })
        document.querySelector(`.sticky-atc-btns .floating-option .option-values[data-option="${option_name}"]`).classList.add('active');
    });
});

document.querySelectorAll('.sticky-atc-btns .floating-option span.cross').forEach(item => {
    item.addEventListener('click', function() {
        const floatingOption = document.querySelector('.sticky-atc-btns .floating-option');
        floatingOption.style.display = 'none';
        
        const activeOption = floatingOption.querySelector('.option-values.active');
        if (activeOption) {
            activeOption.classList.remove('active');
        }
    });
});

document.querySelectorAll('.sticky-atc-btns .floating-option .option-value-wrapper input').forEach(input => {
    input.addEventListener('change', function() {
        const option_value = input.value;
        const option_name = input.getAttribute('name');
        document.querySelectorAll(`.sticky-atc-btns .option-btns[data-option="${option_name}"] button.active`).forEach(btn => {btn.classList.remove('active');});
        const optionButton = document.querySelector(`.option-btns-wrap .option-btns button[data-value="${option_value}"]`);
        const variantInput = document.querySelector(`variant-picker label.variant-option__button-label input[value="${option_value}"]`);

        if (optionButton){ optionButton.classList.add('active');}
        if (variantInput) variantInput.click();
    });
});

/* hide empty accordian */
document.querySelectorAll('.product-information accordion-custom .details-content .ptt-content').forEach(item => {
  if (item.innerHTML.trim() === "") {
    const accordion = item.closest('accordion-custom');
    if (accordion) {
      accordion.style.display = 'none';
    }
  }
});


document.querySelectorAll('.announcement_splide').forEach(function (el) {
  var splide = new Splide(el, {
    type: 'loop',  
    perPage: 1,
    perMove: 1,
    gap: '0rem',
    arrows: true,
    pagination: false,
    autoplay: true, 
    interval: 5000, 
    pauseOnHover: true,
    pauseOnFocus: false
  });

  splide.mount();
});


document.querySelectorAll('.sub_category-wrapper').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 6,
      perMove: 1,
      gap: '15px',
      arrows: false,
      pagination: false,
      padding: { right: '120px', left: '0' },
      breakpoints: {
        1200: {
          perPage: 5,
          padding: { right: '0', left: '0' },
        },
        1024: {
          perPage: 4,
          padding: { right: '0', left: '0' },
        },
        768: {
          perPage: 4,
          gap: '10px',
          padding: { right: '70px', left: '0' },
        },
        640: {
          perPage: 2,
          gap: '10px',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });





